const lead = {
    computed: {
        lead: {
            get(){
                return this.$store.state.lead
            },
            set(payload){
                this.$store.commit('setLead',payload)
            }
        }
    },
}

export default lead;